import React from "react";
import { Box, styled } from "@mui/material";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import { useAppStore } from "../../stores/appStore";

interface DayNightToggleProps {}

const ToggleContainer = styled(Box)<{ isDark: boolean }>(({ isDark }) => ({
  width: 92,
  height: 48,
  borderRadius: 24,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 8px",
  cursor: "pointer",
  position: "relative",
  backgroundColor: isDark ? "#030812" : "#F3F4F6",
  transition: "background-color 0.3s ease",
}));

const IconWrapper = styled(Box)({
  zIndex: 2,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 32,
  height: 32,
});

const Circle = styled(Box)<{ isDark: boolean }>(({ isDark }) => ({
  position: "absolute",
  top: 2,
  left: isDark ? 2 : 46,
  width: 44,
  height: 44,
  borderRadius: "50%",
  backgroundColor: isDark ? "#272937" : "#fff",
  transition: "left 0.3s ease, background-color 0.3s ease",
}));

export const DayNightToggle: React.FC<DayNightToggleProps> = ({}) => {
  const { isDark, setIsDark, updateColorTheme } = useAppStore();

  const handleToggle = () => {
    const newTheme = isDark ? "light" : "dark";
    setIsDark(!isDark);
    updateColorTheme(newTheme);
  };

  return (
    <ToggleContainer isDark={isDark} onClick={handleToggle}>
      <IconWrapper>
        <DarkModeIcon
          sx={{
            color: isDark ? "#06B6D4" : "#c8cbde",
            fontSize: 20,
            transition: "color 0.3s ease",
          }}
        />
      </IconWrapper>
      <IconWrapper>
        <LightModeIcon
          sx={{
            color: isDark ? "#7a869e" : "#06B6D4",
            fontSize: 20,
            transition: "color 0.3s ease",
          }}
        />
      </IconWrapper>
      <Circle isDark={isDark} />
    </ToggleContainer>
  );
};
